import { Skeleton } from '@longy/web-components'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

import { api } from '../../core/trpc'
import { useAuth } from '../../hooks/useAuth'

const PATH = '/bookings/meet/$appointmentId'

/**
 * The only place the video stack is pulled in, and lazily. `livekit-client` is browser-only, and
 * apps/web's optimizeDeps entry pre-bundles it precisely because it is reached this way — a static
 * import here would make that config a lie and drag the SDK into the server bundle.
 */
const ConsultationRoom = lazy(() => import('../../components/video/ConsultationRoom'))

const MeetPage = () => {
    const navigate = useNavigate()
    const { appointmentId } = Route.useParams()
    const { user } = useAuth()

    const { data: appointment } = api.appointment.getByIdForUser.useQuery(
        { id: appointmentId },
        { refetchInterval: 10000 },
    )

    if (!appointment) {
        return <Skeleton className="h-screen w-full" />
    }

    return (
        <Suspense fallback={<Skeleton className="h-screen w-full" />}>
            <ConsultationRoom
                appointmentId={appointmentId}
                appointment={appointment}
                user={
                    user
                        ? { id: user.id, firstName: user.firstName, lastName: user.lastName }
                        : undefined
                }
                onLeave={() =>
                    navigate({ to: '/bookings/$appointmentId', params: { appointmentId } })
                }
            />
        </Suspense>
    )
}

export const Route = createFileRoute(PATH)({
    ssr: false,
    head: () => ({ meta: [{ title: 'Long-Y - Videokonzultáció' }] }),
    component: MeetPage,
})
